import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const groupTradeRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/trades/$id',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    tab: z
      .enum([
        'all',
        'awaiting_validation_by_group',
        'awaiting_validation_by_lab',
        'validated',
        'compensated',
        'refused_by_lab_or_group',
        'subscribed',
        'refused_by_pharmacy',
        'not_subscribed',
      ])
      .default('all'),
  }),
}).lazy(() => import('pages/group/Trades/GroupTradePage/GroupTradePage').then((d) => d.Route));
